import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField } from '../../../components';

import './style.scss';
import PrevNextCard from '../../../components/PrevNext/PrevNextCard';

const VARIANT_DOCUMENT = 'document';

const ParagraphToolkit = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], entity.getIn(['field_text', 0, 'processed']));
  const subTitle = entity.getIn(['field_subtitle', 0, 'value']);
  const items = entity.get('field_subparagraphs');
  const forHomepage = entity.getIn(['field_for_homepage', 0, 'value'], false);

  return (
    <Container>
      <div className={`Paragraph ParagraphToolkit ${forHomepage ? 'ParagraphToolkit__homepage' : ''} `}>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            {title && <h2 className="ParagraphToolkit__title">{title}</h2>}

            {body && (
              <WysiwygField
                property="schema:text"
                className="subheading2"
                html={body}
              />
            )}

            {subTitle && <h5 className="ParagraphToolkit__subTitle">{subTitle}</h5>}

            <div className="ParagraphToolkit__items">
              {items && items.size > 0 && (
                items.map((item, index) => {
                  const itemTitle = item.getIn(['entity', 'field_title', 0, 'value']);
                  const itemSupertitle = item.getIn(['entity', 'field_caption', 0, 'value']);
                  const itemLinkUrl = item.getIn(['entity', 'field_link', 0, 'alias'], item.getIn(['entity', 'field_link', 0, 'uri']));
                  const itemSvg = item.getIn(['entity', 'field_media_image', 0, 'source']);
                  const variant = item.getIn(['entity', 'field_toolkit_variant', 0, 'value']);
                  const uuid = item.getIn(['entity', 'uuid', 0, 'value']);
                  const file = item.getIn(['entity', 'field_file', 0, 'source']);

                  return (
                    <PrevNextCard
                      key={uuid}
                      label={itemSupertitle}
                      showLabel
                      title={itemTitle}
                      svg={itemSvg}
                      path={file && variant === VARIANT_DOCUMENT ? file : itemLinkUrl}
                      toolkitVariant={variant}
                      forToolkit
                      forHomepage={forHomepage}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>

  );
};

export default ParagraphToolkit;
